import { useMemo } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/bg';
export * from './Footer';
export * from './Terms';
export var STATUS = {
    NEW: 'NEW',
    WAITING_CLIENT_RESPONSE: 'WAITING_CLIENT_RESPONSE',
    CLIENT_RESPONSE: 'CLIENT_RESPONSE',
    ACCEPTED: 'ACCEPTED',
    READY: 'READY',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
};
var formatDatetime = function (date, time) {
    return dayjs(date).format('YYYY-MM-DD') + " " + time;
};
var range2string = function (range) {
    var begin = dayjs(range.begin);
    var end = dayjs(range.end);
    var diff = begin.diff(dayjs().startOf('day'), 'day');
    var str = (diff === 0 && 'Днес') ||
        (diff === 1 && 'Утре') ||
        (diff < 0 && begin.format('DD.MM.YYYY [/]')) ||
        begin.format('dddd');
    return str + " " + begin.format('HH:mm') + " - " + end.format('HH:mm');
};
export var usePickupRange = function (minHoursToBegin, existingRange) {
    if (minHoursToBegin === void 0) { minHoursToBegin = 6; }
    var timeNow = dayjs().toISOString().substring(0, 16);
    return useMemo(function () {
        var timeranges = [
            {
                begin: '09:00',
                end: '12:00',
            },
            {
                begin: '12:00',
                end: '15:00',
            },
            {
                begin: '15:00',
                end: '18:00',
            },
            {
                begin: '18:00',
                end: '21:00',
            },
        ];
        var matchingRange = {};
        [0, 1, 2, 3].forEach(function (diff) {
            var date = dayjs(timeNow).add(diff, 'day');
            for (var _i = 0, timeranges_1 = timeranges; _i < timeranges_1.length; _i++) {
                var tr = timeranges_1[_i];
                var r = {
                    begin: formatDatetime(date, tr.begin),
                    end: formatDatetime(date, tr.end),
                };
                if (dayjs(r.begin).diff(dayjs(), 'hour') < minHoursToBegin)
                    continue;
                matchingRange[range2string(r)] = r;
            }
        });
        var pickupRangeOptions = Object.keys(matchingRange).map(function (k) { return ({
            key: k,
            value: k,
            text: k,
        }); });
        if (existingRange && !matchingRange[range2string(existingRange)]) {
            var key = range2string(existingRange);
            matchingRange[key] = existingRange;
            pickupRangeOptions.unshift({ key: key, value: key, text: key });
        }
        return { matchingRange: matchingRange, pickupRangeOptions: pickupRangeOptions, range2string: range2string };
    }, [timeNow, minHoursToBegin, existingRange]);
};
//# sourceMappingURL=index.js.map